export const durationMs = 7000;
